<template>
  <div class="navtab-view">
    <div class="nav-item" v-for="(item, index) in list" :key="index" :class="activeId === index ? 'active': ''" @click="tabClick(item, index)">
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavTabView',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
      activeId: 0
    }
  },
  methods: {
    tabClick: function (item, index) {
      this.activeId = index
      this.$emit('tabClick', item)
    }
  }
}
</script>

<style scoped>
  .navtab-view{
    display: flex;
    flex-direction: row;
    height: 39px;
    border: 1px solid #6FBFB9;
    width:fit-content;
    width:-webkit-fit-content;
    width:-moz-fit-content;
    border-radius: 3px;
  }

  .nav-item{
    width: 129px;
    height: 100%;
    color: #6FBFB9;
    line-height: 39px;
    text-align: center;
    cursor: pointer;

  }

  .active {
    background: #6FBFB9;
    color: #fff;
  }
  
  .line{
    height: 1px;
    width: 100%;
    border-bottom: 1px solid #cccccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/live/NavTabView.vue